import DataTable from "react-data-table-component";
import { Card, CardBody } from "reactstrap";
import { useThemeContext } from "../../../Context/ThemeContext";

const PreviewShiftList = ({ stafList, dateList }) => {
  const { themeContext } = useThemeContext();

  const isWeekend = (date) => {
    const day = date.getDay();
    return day === 0 || day === 6;
  };

  const columns = [
    {
      name: "Nama Staf",
      selector: (row) => row.nama,
      sortable: true,
      wrap: true,
    },
    ...dateList.map((date) => {
      const today = new Date(date.tanggal);
      return {
        name: today.getDate(),
        selector: (row) => {
          const shiftData = row.shift.find(
            s => new Date(s.tanggal).getDate() === today.getDate()
          );
          return <div>{shiftData?.shift_display || '-'}</div>;
        },
        wrap: true,
        conditionalCellStyles: [
          {
            when: () => isWeekend(today),
            style: {
              backgroundColor: '#FFE6E6',
            },
          },
        ],
      };
    }),
  ];

  return (
    <Card>
      <CardBody>
        <DataTable
          data={stafList}
          columns={columns}
          pagination
          selectableRowsHighlight
          highlightOnHover
          dense
          theme={themeContext}
          fixedHeader
          fixedHeaderScrollHeight="400px"
        />
      </CardBody>
    </Card>
  );
};

export default PreviewShiftList;